import { gqlClient } from '@/api/graphql-client';
import estimateKeys from '@/api/queries/estimates/keyFactory';
import { graphql } from '@/gql';
import { useQuery } from '@tanstack/react-query';

/**
 * Appliance recommendations for a SOLAR Estimate, read off the solar
 * potential snapshotted onto the estimate at create time (the solar mirror of
 * `useGetEstimateApplianceRecommendations`, which reads the heat loss
 * snapshot).
 */
const GetEstimateSolarApplianceRecommendationsQuery = graphql(`
  query GetEstimateSolarApplianceRecommendations($estimateId: ID!) {
    estimate(id: $estimateId) {
      id
      solarEstimate {
        summary {
          recommendedPanelAppliances {
            ...SolarRecommendedApplianceFields
          }
          recommendedInverterAppliances {
            ...SolarRecommendedApplianceFields
          }
          recommendedBatteryAppliances {
            ...SolarRecommendedApplianceFields
          }
        }
      }
    }
  }
`);

const useGetEstimateSolarApplianceRecommendations = (estimateId?: string) => {
  const { data, ...rest } = useQuery({
    enabled: !!estimateId,
    queryKey: estimateKeys.solarApplianceRecommendations(estimateId),
    queryFn: () =>
      gqlClient.request(GetEstimateSolarApplianceRecommendationsQuery, {
        estimateId: estimateId!,
      }),
    meta: { errorMessage: 'Failed to load recommended Appliances' },
  });

  const summary = data?.estimate?.solarEstimate?.summary;
  return {
    recommendedPanels: summary?.recommendedPanelAppliances,
    recommendedInverters: summary?.recommendedInverterAppliances,
    recommendedBatteries: summary?.recommendedBatteryAppliances,
    ...rest,
  };
};

export default useGetEstimateSolarApplianceRecommendations;
